var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      "label-width": "100px",
      model: _vm.formData,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "区服"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容",
      disabled: true
    },
    model: {
      value: _vm.serverList[this.serverId],
      callback: function callback($$v) {
        _vm.$set(_vm.serverList, this.serverId, $$v);
      },
      expression: "serverList[this.serverId]"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "角色ID"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容",
      disabled: true
    },
    model: {
      value: this.roleId,
      callback: function callback($$v) {
        _vm.$set(this, "roleId", $$v);
      },
      expression: "this.roleId"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "封号原因"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.formData.ban_reason,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "ban_reason", $$v);
      },
      expression: "formData.ban_reason"
    }
  }), _c("div", [_c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setBanReason("拉人");
      }
    }
  }, [_vm._v("拉人")]), _c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setBanReason("刷bug");
      }
    }
  }, [_vm._v("刷bug")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "封禁时间/秒"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入时长"
    },
    model: {
      value: _vm.formData.time,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "time", $$v);
      },
      expression: "formData.time"
    }
  }), _c("div", [_c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setTime(1 * _vm.hour);
      }
    }
  }, [_vm._v("1小时")]), _c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setTime(4 * _vm.hour);
      }
    }
  }, [_vm._v("4小时")]), _c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setTime(1 * _vm.day);
      }
    }
  }, [_vm._v("1天")]), _c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setTime(3 * _vm.day);
      }
    }
  }, [_vm._v("3天")]), _c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setTime(50 * _vm.year);
      }
    }
  }, [_vm._v("永久")])], 1)], 1)], 1), _c("div", {
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.banRole();
      }
    }
  }, [_vm._v("封号")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };